//注意!!!!打包上線流程用，不要修改/刪除這個文件!!!!!

//這個文件在打包階段會自動生成最新版，並覆蓋，所以改了推上去也沒用，只用於本地開發時，測試功能
const seoStatic = {
  mainDomain: 'fun88thb.net',
};
module.exports = seoStatic;
